<style>
/* table {
  text-align: left;
} */
/* table th {
  text-align: center;
} */
table thead th {
  background-color: rgb(26, 54, 101) !important;
  color: white;  
}
table .file {
  text-align: center !important;
}
.bg-primary {
  background-color: #1a3665 !important;
}
.form-control {
  color: #272727 !important;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.bg-active {
  background-color: #214073 !important;
}
.bg-subactive {
  background-color: #2e518c !important;
}
.swal2-actions {
  flex-direction: row-reverse !important;
}
button.btn.dropdown-toggle.btn-warning {
  color: white !important;
}
.calendar-table .table-condensed thead tr th {
  background-color: white !important;
  color: black !important;
}
</style>
<template>
  <div class="c-app">
    <audio id="notification" src="/piece-of-cake.mp3"  muted="false"></audio>
    <TheSidebar />
    <CWrapper>
      <TheHeader :notif_props="item" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import authHeader from "../services/auth-header";
import baseUrl from "../services/base-url"
import baseUrlFrontend from "../services/baser-url-frontend"

import axios from "axios";

import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
export default {
  name: "TheContainer",
  data() {
    return {
      received_messages: [],
      send_message: null,
      connected: false,
      totalNotif: 0,
      item : [],
      stompClient : null,
      socket : null,
    };
  },
   watch:{
    $route (to, from){
        this.check();
    }
  },
   
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  mounted() {
    // this.$store.dispatch('auth/checkAuth')
    // if(!this.$store.state.auth.status.statusAuth){
    //   this.$router.push('/pages/login');
    // }
    this.check();
    this.connect();
    if (!Notification) {
      alert('Desktop notifications not available in your browser. Try Chromium.');
      return;
    }

    if (Notification.permission !== 'granted'){
      Notification.requestPermission();
    }
  },
  methods: {
    check() {
      axios
        .get(baseUrl()+"/api/all/check-auth", {
          headers: authHeader()
        })
        .then(() => {
          return true;
        })
        .catch(() => {
        
          this.$router.push({ name: "Login" });
          this.$store.dispatch("auth/logout");
        });
    },
    send() {
        // alert("hahah")
      // comment console console.log("Send message:" + this.send_message);
      if (this.stompClient) {
        const msg = { 
          sender: "message",
          content: "mesge"
        };
        this.stompClient.send("/app/user", {}, {});
      }
    },
    notifyMe(message) {
      if (Notification.permission !== 'granted')
        Notification.requestPermission();
      else {
        document.getElementById('notification').muted = false;
        document.getElementById('notification').play();
        var notification = new Notification(message.title, {
          icon: '/img/iapi-logo.png',
          body: message.message,
          sound: '/piece-of-cake.mp3'
        });
        notification.onclick = function() {
          window.open(baseUrlFrontend());
        };
      }
    },
    connect() {
      this.socket = new SockJS("http://localhost:9093/notification-back-office",{
        protocolVersion: 8,
        origin:'http://localhost:9093/',
        rejectUnauthorized: false
      });
      this.stompClient = Stomp.over(this.socket);
      var stompClient = this.stompClient
      //  var socket = new SockJS('/javatechie');
      var vm = this;
      // this.stompClient.connect({}, onConnected, onError);
      this.stompClient.connect({},function(frame) {
          // // comment console console.log(frame);
            // // comment console console.log("INI NOTIFFFFF")
          // // comment console console.log(frame)
          stompClient.subscribe("/topic/user-notif", function(response) {
            // comment console console.log("INI NOTIFFFFF")
            var jes = JSON.parse(response.body);
            vm.notifyMe(jes);
            // // comment console console.log(jes.title);
            // // comment console console.log(response)
            vm.item.push(jes);
          });
        }
      );
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    tickleConnection() {
      this.connected ? this.disconnect() : this.connect();
    },
    check() {
      axios
        .get(baseUrl()+"/api/all/check-auth", {
          headers: authHeader()
        })
        .then(() => {
          return true;
        })
        .catch(() => {
          this.$router.push({ name: "Login" });
          this.$store.dispatch("auth/logout");
        });
      }
    }
};
</script>

<style scoped>
.usermanajemen {
  background: green;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
